<template>
  <div class="services-component">
    <MenuComponent>
      <template v-slot:toggle>
        <QIcon name="apps"></QIcon>
      </template>
      <MenuListItemComponent @click="triggerLink(`https://plan.${tld}`)">
        <template v-slot:icon>
          <QIcon name="rocket_launch"></QIcon>
        </template>
        <template v-slot:default>
          {{ $t('plan') }}
        </template>
      </MenuListItemComponent>
      <MenuListItemComponent @click="triggerLink(`https://community.${tld}`)">
        <template v-slot:icon>
          <QIcon name="workspaces"></QIcon>
        </template>
        <template v-slot:default>
          {{ $t('community') }}
        </template>
      </MenuListItemComponent>
    </MenuComponent>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { getLocale } from './Utils';

const show = ref(false);

/** @ts-ignore **/
const tld = TLD;

const triggerLink = (link) => {
  const a = document.createElement('a');
  a.href = `${link}/${getLocale()}`;
  a.target = '_blank';
  document.body.appendChild(a);
  a.click();
  a.remove();
}

</script>

<style lang="scss" scoped>
.services-component {
  --menu-width: 300px;
  ::v-deep(.menu-component) {
    .menu-list {
      z-index: 10;
    }
  }
}
</style>

